import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="text-xs font-semibold tracking-[0.2em] text-accent-700">FAQ / 常见问题</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              常见问题解答
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              以下是观众在寻找观看入口时最常遇到的一批问题。点击任意一条即可展开查看解答，
              内容已全部在页面中，无需跳转。
            </p>
            <div className="mt-6 rounded-xl border border-background-200 bg-background-100 p-5">
              <p className="flex items-center gap-2 text-sm font-medium text-foreground-800">
                <i className="ri-customer-service-2-line text-primary-600"></i>
                还有别的问题？
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                可以先看看上方的「资源导航」与「查找方法」，多数疑问都能在那里找到对应的思路。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-100">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-200/60 md:px-6"
                      >
                        <span className="flex items-start gap-3">
                          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-semibold text-primary-700">
                            Q
                          </span>
                          <span className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</span>
                        </span>
                        <i
                          className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                            isOpen ? "rotate-45" : ""
                          }`}
                        >
                          <span className="ri-add-line"></span>
                        </i>
                      </button>
                    </h3>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-16">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}